<template>
  <div>
    <b-modal
      id="modal-bulk-action"
      ref="modal"
      v-model="open"
      hide-footer
      no-close-on-backdrop
      size="lg"
      title="BULK ACTION"
      class="p-4"
    >
      <template #modal-header>
        <h5 class="modal-title">
          BULK ACTION
        </h5>
        <button
          v-if="!loadingResponse"
          type="button"
          class="close"
          :disabled="loadingResponse"
          @click="handleCloseButtonClick"
        >
          <span>&times;</span>
        </button>
      </template>

      <!-- Ignore all input fields checkbox -->
      <b-row
        v-if="hasInputFields && !hasFieldValue"
        class="mb-2"
      >
        <b-col>
          <b-form-checkbox
            v-model="notRequired"
            class="ml-1 mt-2"
            :disabled="hasWeightValue"
          >
            Ignore all input fields below (Existing data will be submitted)
          </b-form-checkbox>
        </b-col>
      </b-row>

      <!-- Input fields (if any) -->
      <b-row
        v-if="hasInputFields"
        class="mb-2"
      >
        <b-col>
          <form-builder
            ref="formbuilderBulkAction"
            v-model="formData"
            :on-submit="onSubmit"
            grid-class="px-1 row"
            :form-structure="formStructure"
            @warehouse_idOnChange="onWarehouseChange"
          />
        </b-col>
      </b-row>

      <!-- Collected COD section -->
      <b-row
        v-if="statusKey === 'key_7' || statusKey === 'key_13'"
        class="mb-2"
      >
        <b-col>
          <div class="font-weight-bold mb-1">
            Collected COD
          </div>
          <div>{{ totalCOD }}</div>
        </b-col>
      </b-row>

      <!-- Separator -->
      <hr>

      <!-- Waybill Numbers -->
      <h5 class="mb-2 ml-1">
        Waybill Numbers
      </h5>
      <b-badge
        v-for="(waybill, index) in waybillArray"
        :key="index"
        variant="light-primary"
        class="mr-1 mb-1 ml-1"
      >
        {{ waybill }}
      </b-badge>

      <!-- Separator -->
      <hr>

      <b-row class="mt-2 mb-2 mr-1">
        <b-col class="d-flex justify-content-end">
          <b-button
            type="submit"
            class="vh-5 ml-1"
            variant="primary"
            :disabled="loadingResponse"
            @click="onSubmit"
          >
            {{ loadingResponse ? 'Submitting...' : 'Submit' }}
          </b-button>
        </b-col>
      </b-row>

      <!-- Error table -->
      <b-row
        v-if="errors.length > 0"
        class="mt-4"
      >
        <b-col>
          <b-table
            striped
            hover
            responsive
            :items="errors"
            :fields="fields"
          >
            <template #cell(status)="data">
              <b-badge variant="light-danger">
                {{ data ? 'error' : 'success' }}
              </b-badge>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BBadge,
  VBModal,
  BCol,
  BRow,
  BButton,
  BTable,
  BFormCheckbox,
  // BTooltip,
} from 'bootstrap-vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Ripple from 'vue-ripple-directive'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FormBuilder from '@/libs/builders/form-builder/FormBuilder.vue'

const orderRepository = RepositoryFactory.get('order')

const INPUT_FIELD_TYPES = [
  'input',
  'select',
  'textarea',
  'number',
  'date',
  'email',
  'tel',
]

function initialState() {
  return {
    open: false,
    formData: {},
    errors: [],
    loadingResponse: false,
    notRequired: false,
    fields: [
      {
        key: 'waybill_number',
        label: 'Waybill Number',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'status',
        label: 'Status',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'error',
        label: 'Error',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
    ],
  }
}

export default {
  name: 'KeyFourModal',
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BModal,
    BBadge,
    BCol,
    BRow,
    BButton,
    FormBuilder,
    BTable,
    BFormCheckbox,
    // BTooltip,
  },
  mixins: [SuccessMessage, ErrorMessage],
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    form_structure: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => [],
    },
    // eslint-disable-next-line vue/prop-name-casing
    status_key: {
      type: String,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    selected_waybill_array: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    // eslint-disable-next-line vue/prop-name-casing
    truck_driver: {
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/prop-name-casing
    order_settings: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      localFormStructure: [],
      box: '',
      totalCOD: 0,
      ...initialState(), // Spread the properties from initialState() if necessary
    }
  },
  computed: {
    formStructure() {
      return this.form_structure.filter(n => n.value !== 'waybill_number').map(m => {
        const obj = m
        return obj
      })
    },
    statusKey() {
      return this.status_key
    },
    waybillArray() {
      return this.selected_waybill_array
    },
    hasInputFields() {
      return this.formStructure.some(field => INPUT_FIELD_TYPES.includes(field.type))
    },
    hasFieldValue() {
      const values = this.formStructure.map(field => field.value)
      const hasRider = values.includes('rider_id') || values.includes('return_rider_id')
      const hasWeightSet = values.includes('weight')
        && values.includes('receiver_name')
        && values.includes('receiver_id')
      const handedOverToMerchant = values.includes('receiver_name') && values.includes('receiver_id')
      const onlyWarehouse = values.length === 1 && values[0] === 'warehouse_id'
      return onlyWarehouse || hasRider || hasWeightSet || handedOverToMerchant
    },
    hasWeightValue() {
      const { weight } = this.formData
      return weight !== null && weight !== undefined && String(weight).trim() !== ''
    },
  },
  watch: {
    notRequired() {
      this.updateInputDisabledState()
      this.updateInputRequiredState()
    },
    hasWeightValue(hasValue) {
      if (hasValue && this.notRequired) {
        this.notRequired = false
      }
    },
  },
  methods: {
    async onWarehouseChange(warehouseId) {
      // Call the parent's onWarehouseChange method
      if (this.$parent?.onWarehouseChange) {
        await this.$parent.onWarehouseChange(warehouseId)
        this.updateDropdownOptions('destination_city_id', this.$parent.cityOptions || [])

        // Enable/disable city dropdown based on warehouse selection
        const cityFieldIndex = this.localFormStructure.findIndex(field => field.value === 'destination_city_id')
        if (cityFieldIndex !== -1) {
          this.$set(this.localFormStructure[cityFieldIndex], 'disabled', !warehouseId)
        }
      }
    },
    // eslint-disable-next-line camelcase
    async openModal() {
      await Object.assign(this.$data, initialState())
      this.loadingResponse = false
      this.removeDisabled()
      this.open = true
      if (this.statusKey === 'key_7' || this.statusKey === 'key_13') {
        const relevantRows = this.rows.filter(row => this.waybillArray.includes(row.waybill_number))
        this.totalCOD = relevantRows.reduce((total, row) => total + row.cod, 0)
        this.totalCOD = this.totalCOD.toLocaleString('en-US', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }
      // Deep clone parent structure → becomes reactive locally
      this.localFormStructure = this.form_structure.filter(n => n.value !== 'waybill_number')

      // Initialize all dropdown options
      this.initializeDropdownOptions()
    },

    initializeDropdownOptions() {
      this.localFormStructure.forEach((field, index) => {
        if (field.type === 'select' && field.fetchData) {
          this.updateDropdownOptions(field.value, field.fetchData, index)
        }
      })
    },

    updateDropdownOptions(fieldValue, data = [], fieldIndex = null) {
      const index = fieldIndex ?? this.localFormStructure.findIndex(field => field.value === fieldValue)
      if (index === -1) return

      const field = this.localFormStructure[index]
      const formattedOptions = this.formatDropdownOptions(data, field.fetchFilter)

      this.$set(this.localFormStructure[index], 'fetchData', data)
      this.$set(this.localFormStructure[index], 'options', formattedOptions)
    },

    formatDropdownOptions(data, fetchFilter) {
      if (fetchFilter && typeof fetchFilter === 'function') {
        return data.map(item => fetchFilter(item))
      }

      return data.map(item => ({
        label: item.name || item.label || String(item),
        value: item.id || item.value || item,
      }))
    },
    async handleCloseButtonClick() {
      this.open = false
    },
    async onSubmit() {
      const missingFields = this.formStructure
        .filter(field => field.required)
        .filter(field => {
          const value = this.formData[field.value]
          if (field.value === 'weight') {
            return value === '' || value === null || value === undefined
          }
          return !value
        })

      if (missingFields.length > 0) {
        this.showErrorMessage('Please fill all required fields.')
        return
      }

      const truckDriverEnabled = localStorage.getItem('truck_driver_enabled')
      try {
        this.loadingResponse = true
        const payload = {}
        if (!this.formData.driver_id) {
          this.formData.driver_id = null
        }
        const otherDetails = { ...this.formData }
        // When "Ignore" is checked, omit input fields so existing order data is kept
        if (this.notRequired) {
          this.formStructure.forEach(field => {
            if (INPUT_FIELD_TYPES.includes(field.type)) {
              delete otherDetails[field.value]
            }
          })
        }
        payload.other_details = otherDetails
        payload.waybill_numbers = this.waybillArray
        payload.status_key = this.statusKey
        if (this.statusKey === 'key_11') {
          payload.other_details.is_bulk = true
        }
        if (this.statusKey === 'key_10') {
          payload.truck_driver = Boolean(!truckDriverEnabled) || this.truck_driver
        }
        await orderRepository.updateOrderStatus(payload)
        this.loadingResponse = false
        this.showSuccessMessage('Order updated successfully')
        this.open = false
        this.$parent.selectedWaybillArray = []
        this.$parent.selectAllCheckbox = false
        this.$parent.onClickRefresh()
      } catch (e) {
        this.loadingResponse = false
        this.errors = []
        const mainErrorMessage = e.response.data.message
        const detailedErrors = e.response.data.errors || {}

        if (Object.keys(detailedErrors).length > 0) {
          Object.entries(detailedErrors).forEach(([, fieldErrors]) => {
            fieldErrors.forEach(error => {
              const combinedErrorMessage = `${mainErrorMessage} ${error}`
              this.errors.push({ waybill_number: '---', error: combinedErrorMessage })
            })
          })
        } else if (typeof mainErrorMessage === 'string') {
          this.errors.push({ waybill_number: '---', error: mainErrorMessage })
        } else {
          Object.entries(mainErrorMessage).forEach(([, element]) => {
            this.errors.push({ waybill_number: element.waybill_number, error: element.error })
          })
        }
      }
    },
    removeDisabled() {
      this.localFormStructure.forEach((field, idx) => {
        // Don't enable city dropdown unless warehouse is already selected
        if (field.value === 'destination_city_id') {
          // Keep city disabled if no warehouse is selected in the form data
          this.$set(this.localFormStructure[idx], 'disabled', !this.formData.warehouse_id)
        } else {
          this.$set(this.localFormStructure[idx], 'disabled', false)
        }
      })
    },
    updateInputDisabledState() {
      this.formStructure.forEach((field, idx) => {
        if (INPUT_FIELD_TYPES.includes(field.type)) {
          this.$set(this.formStructure[idx], 'disabled', this.notRequired)
        }
      })
    },
    updateInputRequiredState() {
      this.formStructure.forEach((field, idx) => {
        if (INPUT_FIELD_TYPES.includes(field.type)) {
          this.$set(this.formStructure[idx], 'required', !this.notRequired)
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
